import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "chat-attached-messages__item-body" }
const _hoisted_2 = { class: "chat-attached-messages__item-body-header" }
const _hoisted_3 = { class: "chat-attached-messages__item-body-header-name" }
const _hoisted_4 = { class: "chat-attached-messages__item-body-header-date" }
const _hoisted_5 = { class: "chat-attached-messages__item-body-text" }

import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppLoader from "@/components/ui-kit/loader/AppLoader.vue";
import moment from "moment";
import {ChatsApi} from "@/ api/ChatsApi";
import {AttachedMessage} from "@/store/chats";
import {applyChatMessagePlaceholders} from "@/utils/textHelpers";
import { useModalEscape } from "@/composables/useModalEscape";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatAttachedMessages',
  setup(__props, { expose: __expose }) {

const isLoading = ref(false);
const messages = ref<AttachedMessage[] | null>(null)
const $modal = ref<typeof BaseModal | null>(null)
const $content = ref<HTMLElement | null>(null)

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
	content: $content,
	close: () => $modal.value?.onClose()
})

const onOpen = async (messageId: number) => {
	$modal.value?.onOpen();
	activateEsc();

	try {
		isLoading.value = true;
		messages.value = await ChatsApi.getAttachedMessages(messageId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false;
	}
}

const getDialogDate = (date: string) => moment(date).format("DD.MM.YYYY HH:mm");

// текст выводится интерполяцией, а не через v-html — подставляем плейсхолдеры без разметки
const messageText = (message: AttachedMessage) =>
	applyChatMessagePlaceholders(message.Text ?? '', message.Links, message.Bills, { plainText: true });

__expose({ onOpen })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    height: 490,
    width: 572,
    onOnClose: _unref(deactivateEsc)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "$content",
        ref: $content,
        class: "chat-attached-messages"
      }, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(messages.value, (message) => {
              return (_openBlock(), _createElementBlock("div", {
                key: message.Id,
                class: "chat-attached-messages__item",
                style: _normalizeStyle({ paddingLeft: `${message.Level * 8}px` })
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "chat-attached-messages__item-label" }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(message.Sender.Name), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(getDialogDate(message.Date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(messageText(message)), 1)
                ])
              ], 4))
            }), 128))
      ], 512)
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}
}

})